import { AuthService } from 'modules/authService/service';

let authService: AuthService | undefined;

export function setAuthService(service: AuthService) {
  authService = service;
}

export { authService };
